<template>
  <div class="user-bg">
    <router-link to="/">
      <img class="user-logo" src="../../assets/img/logo.png">
    </router-link>
    <div class="user-container">
      <div class="form-container">
        <h3>{{$t("signup.title")}}</h3>
        <div class="user-form">
          <el-form :model="regForm" status-icon :rules="regRule" ref="regForm">
            <el-form-item prop="username" :label="$t('signup.username')">
              <el-input type="username" v-model="regForm.username" autocomplete="off" @keyup.enter.native="submitForm"></el-input>
            </el-form-item>
            <el-form-item prop="email" :label="$t('signup.email')">
              <el-input type="email" v-model="regForm.email" autocomplete="off" @keyup.enter.native="submitForm">
                <el-button slot="append" @click="getVerifyCode" :title="$t('common.sendCodeTip')">{{$t("common.sendCode")}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item prop="code" :label="$t('common.verifyCode')">
              <el-input v-model="regForm.code" @keyup.enter.native="submitForm"></el-input>
            </el-form-item>
            <el-form-item prop="pass" :label="$t('signup.password')">
              <el-input type="password" v-model="regForm.pass" autocomplete="off" @keyup.enter.native="submitForm"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass" :label="$t('signup.confirm')">
              <el-input type="password" v-model="regForm.checkPass" autocomplete="off" @keyup.enter.native="submitForm"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm">{{$t("signup.signup")}}</el-button>
              <recaptcha ref="recaptcha" @verify="submit"></recaptcha>
            </el-form-item>
          </el-form>
        </div>
        <div class="serviceBox">{{$t("signup.privacyBegin")}}
          <router-link to="/terms" class="go-regi">{{$t("signup.service")}}</router-link>{{$t("signup.privacyAnd")}}
          <router-link to="/privacy" class="go-regi">{{$t("signup.privacy")}}</router-link>{{$t("signup.privacyEnd")}}
        </div>
      </div>
      <div class="signUp">
        <p>{{$t("signup.haveAccount")}}
          <router-link to="/login" class="go-regi">{{$t("signup.login")}}</router-link>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { resCode, pattern } from "../../../server/common/data";
import { doRegister, sendVerifyCode } from "../../request";
import api from "../../api/api";
import Recaptcha from "../Recaptcha";
import { getCookie } from "../../common/utils";
const validator = require("validator");

export default {
  components: {
    Recaptcha
  },
  data() {
    var validateUser = (rule, value, cb) => {
      if (value === "") {
        cb(new Error(this.$t('common.usernameRequried')));
      } else if (!pattern.username.test(value)) {
        cb(new Error(this.$t('common.usernameFormat')));
      } else {
        api
          .checkUserExist({username: value})
          .then(res => {
            if (res.data.CODE !== resCode.USER_NOT_FOUND) {
              cb(new Error(this.$t('signup.usernameUsed')));
            } else {
              cb();
            }
          })
          .catch(() => {
            cb();
          });
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('common.emailRequried')));
      } else {
        if (validator.isEmail(value)) {
          api
            .checkUserExist({email: value})
            .then(res => {
              if (res.data.CODE !== resCode.USER_NOT_FOUND) {
                callback(new Error(this.$t('signup.emailUsed')));
              } else {
                callback();
              }
            })
            .catch(() => {
              callback();
            });
        } else {
          callback(new Error(this.$t('common.emailFormat')));
        }
      }
    };
    var validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('common.verifyCodeRequried')));
      } else {
        if (validator.isLength(value, {min: 6, max: 6}) && validator.isAlphanumeric(value)) {
          callback();
        } else {
          callback(new Error(this.$t('common.verifyCodeFormat')));
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('common.passwordRequried')));
      } else {
        if (pattern.password.test(value)) {
          callback();
        } else {
          callback(new Error(this.$t('common.passwordFormat')));
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('signup.confirmPwdRequried')));
      } else if (value !== this.regForm.pass) {
        callback(new Error(this.$t('signup.confirmPwdMismatch')));
      } else {
        callback();
      }
    };
    return {
      regForm: {
        username: "",
        email: "",
        code: "",
        pass: "",
        checkPass: ""
      },
      regRule: {
        username: [{ validator: validateUser, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.regForm.validate(valid => {
        if (valid) {
          if (getCookie("test_token")) {
            this.submit(""); // skip google reCaptcha at test
          } else {
            this.$refs.recaptcha.execute();
          }
        } else {
          return false;
        }
      });
    },
    getVerifyCode() {
      this.$refs.regForm.validateField("email", err => {
        if (!err) {
          let data = {
            email: this.regForm.email,
            act: "register"
          };
          sendVerifyCode(this, data);
        } else {
          return false;
        }
      });
    },
    submit(token) {
      let data = {
        username: this.regForm.username,
        password: this.regForm.pass,
        email: this.regForm.email,
        code: this.regForm.code,
        recaptcha_token: token
      };
      doRegister(this, data);
    }
  }
};
</script>
<style lang="scss">
.serviceBox {
  width: 320px;
  font-size: 14px;
  line-height: 26px;
  text-align: center;
  margin: 0 auto;
  a {
    font-weight: bold;
  }
}
</style>





// WEBPACK FOOTER //
// Register.vue?fc3bb604